import { isMobile } from '@/utils/devices';
import { GTM } from '@/utils/tracking/gtm/constants';
import { ORIENTATIONS } from '@/utils/constants';
import { getGameName, getProviderName, getVideoUrl } from '../game-adapter/game-adapter';
import type { ExclusiveZone } from '@/types/zones/exclusive-zone';
import type { Brand, Region } from '@/types/constants';

export const getExclusiveProps = (props: ExclusiveZone) => {
    const isMobileDevice = isMobile(); // serverside this is always true, probably not intended
    const layoutVariant = isMobileDevice ? ORIENTATIONS.PORTRAIT : ORIENTATIONS.LANDSCAPE;

    const zoneContent: any = props?.data;
    const layoutContent = zoneContent?.[layoutVariant]?.[0];
    const gameContent = zoneContent?.select_game;
    const gameData = gameContent?.data;
    const videoTrailerUrl = getVideoUrl(gameContent?.data?.video_trailer);
    const hasAllContent = !!(layoutContent?.primary && layoutContent?.id && videoTrailerUrl);
    const shouldDisplayPostLaunchPopup =
        zoneContent?.show_popup_at_login && isMobileDevice && hasAllContent && props?.loggedIn;
    const copyrightText = gameData?.copyright_text;
    const logoUrl = layoutContent?.primary?.logo?.url;

    const launcherUrlProps = {
        providerName: getProviderName(gameContent?.data?.provider?.data?.providername),
        region: props?.region as Region,
        brand: process?.env?.BRAND as Brand,
        gameName: getGameName(gameContent?.data?.display_name),
        rgi: gameData?.rgi,
        ganId: gameData?.ganid,
        providerRef: isMobileDevice ? gameData?.rgs_code_mobile : gameData?.rgs_code_desktop,
        gameId: gameContent?.id,
        gameUid: gameContent?.uid
    };

    const trailerProps = {
        url: zoneContent?.video_trailer?.url,
        id: layoutContent?.id,
        launchParameters: launcherUrlProps,
        gtmGame: {
            noDefaultValues: true,
            event: GTM.EVENTS.CLICKED_PLAY_NOW,
            cd3: 'exclusive_post_launch'
        },
        gtmVideo: {
            noDefaultValues: true,
            event: GTM.EVENTS.CLICKED_PLAY_NOW,
            cd3: 'exclusive_post_launch_video'
        },
        gameName: getGameName(gameContent?.data?.display_name),
        gameInfo: gameData?.native_description?.[0]?.text || '',
        gameContent,
        legalText: gameData?.copyright_text,
        amplitudeEvents: props?.amplitudeEvents,
        poster: layoutContent?.primary?.video_loading_placeholder?.url,
        zoneUid: props?.uid,
        promo_url: props?.data?.promo_url,
        promo_code: props?.data?.promo_code
    };

    const gameDetailsProps = {
        description: zoneContent?.description,
        launchParameters: launcherUrlProps,
        gtmVideo: {
            noDefaultValues: true,
            event: GTM.EVENTS.CLICKED_PLAY_NOW,
            cd3: 'exclusive_post_launch_video'
        },
        promo_url: props?.data?.promo_url,
        promo_code: props?.data?.promo_code
    };

    return {
        copyrightText,
        logoUrl,
        layoutContent,
        trailerProps,
        gameDetailsProps,
        shouldDisplayPostLaunchPopup
    };
};
